import { render } from "./MKassa.vue?vue&type=template&id=bec7d632"
import script from "./MKassa.vue?vue&type=script&lang=js"
export * from "./MKassa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__